import { on, off, throttle, isInViewport } from './utils/_fn';

(function (window, document) {
    /* ---------------------------------------- [START] Windows Setting */
	const html = document.documentElement;
	const body = document.body;
	let ww = window.innerWidth;
	let wh = window.innerHeight;
	let ws = 0;
	function getScrollTop(target = window) {
		return (target.pageYOffset || html.scrollTop) - (html.clientTop || 0);
	}
	function getWinSet() {
		ww = window.innerWidth;
		wh = window.innerHeight;
		ws = getScrollTop();
	}
	on(window, 'load', getWinSet);
	on(window, 'resize', throttle(getWinSet, 50, 100));

	/* ---------------------------------------- [START] 整頁 Scroll 監測 (Before) */
	var pageScrollCheckList = []; // 紀錄物件
	var pageScrollAdd = function (selector, buildFunction) {
		var el = document.querySelector(selector);
		if (el === null) {
			return false;
		}
		pageScrollCheckList.push({
			build: false,
			el: el,
			fun: buildFunction,
		});
	};
	var pageScrollClear = function () {
		pageScrollCheckList = Array.prototype.filter.call(pageScrollCheckList, function (item) {
			return item.build === false;
		});
	};
	/* ---------------------------------------- [START] //footer */
    // 定義一個函數來更新樣式
    function adjustLayout() {
        // 取得 warning 元素的高度
        var warningHeight = $('#warning').outerHeight();
        
        // 設置 .copy 的 margin-bottom 為 warning 的高度
        $('.copy').css('margin-bottom', warningHeight + 'px');
        
        // 設置 .voter_btn_side 的 bottom 為 warning 的高度再加上 20px
        $('.voter_btn_side').css('bottom', (warningHeight + 20) + 'px');
    }

    // 頁面加載時執行一次調整
    adjustLayout();

    // 當螢幕大小調整時，重新執行調整
    $(window).resize(function() {
        adjustLayout();
    });

	/* ----------------------------------- [START] Set YT */
	$('.ytvideo[data-video]').on('click', function() {
		$('.yt_outline').delay(500).fadeOut(4000);
		$('.yt__deco-leaf').delay(500).fadeOut(100);
		$(this).html('<iframe src="//www.youtube.com/embed/'+$(this).data("video")+'?rel=0;&autoplay=1&mute=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>');
	});
	/* ----------------------------------- [START]filter */
	function TagFilter(){
		// 初始化，顯示全部的項目
		$('.store__item').fadeIn();

		// 點擊按鈕時觸發事件
		$('a[data-filter]').click(function() {
			// 移除所有按鈕的 is-active 樣式
			$('a[data-filter]').removeClass('is-active');
			// 添加點擊的按鈕的 is-active 樣式
			$(this).addClass('is-active');

			// 獲取按鈕的 data-filter 值
			var filter = $(this).data('filter');

			// 隱藏所有項目，並以動畫效果淡出
			$('.store__item').fadeOut();

			// 顯示符合篩選條件的項目，並以動畫效果淡入
			if (filter === 'all') {
			  $('.store__item').fadeIn();
			} else {
			  $('.store__item[data-filter-cat="' + filter + '"]').fadeIn();
			}
		});
	}
	TagFilter();
	/* ---------------------------------------- [START]  reports swiper */
	const reportsCarousel = '#reports-carousel';
	function reportsBuild() {
		const swiperTarget = reportsCarousel;
		const swiperEl = document.querySelector(swiperTarget).parentElement;
		const swiperNextEl = swiperEl.querySelector('.custom-next-button');
		const swiperPrevEl = swiperEl.querySelector('.custom-prev-button');

		const swiper = new Swiper(swiperTarget, {
			slidesPerView: 2,
			spaceBetween: 20,
			loop: true,
			navigation: {
				nextEl: swiperNextEl,
				prevEl: swiperPrevEl,
			},
			breakpoints: {
				// >= 640px
				1024: {
					slidesPerView: 4,
					slidesPerGroup: 4,
					spaceBetween: 35,
				}
			}
		});
	}
	on(window, 'load', function () {
		pageScrollAdd(reportsCarousel, reportsBuild);
	});
	/* ---------------------------------------- [START]  top20 swiper */
	const topCarousel = '#top-carousel';
	function topBuild() {
		const swiperTarget = topCarousel;
		const swiperEl = document.querySelector(swiperTarget).parentElement;
		const swiperNextEl = swiperEl.querySelector('.custom-next-button');
		const swiperPrevEl = swiperEl.querySelector('.custom-prev-button');

		const swiper = new Swiper(swiperTarget, {
			slidesPerGroup: 1,
			loop: true,
			centeredSlides: true,
			navigation: {
				nextEl: swiperNextEl,
				prevEl: swiperPrevEl,
			},
			breakpoints: {
				// when window width is >= 320px
				320: {
					slidesPerView: 1.5,
					spaceBetween: 20,
				},
				// when window width is >= 480px
				480: {
					slidesPerView: 2.5,
					spaceBetween: 30,
				},
				1366: {
					slidesPerView: 3.5,
					spaceBetween: 40,
				},
				1660: {
					slidesPerView: 4.5,
					spaceBetween: 40,
				}
			}
		});
	}
	on(window, 'load', function () {
		pageScrollAdd(topCarousel, topBuild);
	});
	/* ---------------------------------------- [START] //設定彈窗顯示 */
	var popup = new Foundation.Reveal($('#ask'));
	popup.open();

	popup.$element.on('closed.zf.reveal', function() {
		$('body').css('overflow-y', 'auto');
	});
	// 警語彈窗關閉
	$('#yea_btn').on('click', function () {
		popup.close();
	});

	/* ---------------------------------------- [START] ＧＳＡＰ動態 */
	// 全區動畫
	function mainAnimation() {
		let aniSec = document.querySelectorAll('.js-ani');
		const elements = [
			{ element: '.banner', start: 'top center', end: 'bottom center'},
			{ element: '.culture', start: 'center center', end: 'bottom center'},
			{ element: '.bartender', start: 'center center', end: 'bottom center'},
			{ element: '.top20', start: 'center center', end: 'bottom center'},
			{ element: '.yt', start: 'center center', end: 'bottom center'},
			{ element: '.sec_media', start: 'center center', end: 'bottom center'},
			{ element: '.store', start: 'top center', end: 'bottom center'}
		];
		elements.forEach((item, index) => {
			const element = document.querySelector(item.element);
			const trigger = element.closest('.sec');
			gsap.to(element, {
				scrollTrigger: {
					trigger: trigger,
					start: item.start,
					end: item.end,
					// markers: true, 
					onEnter: () => {
						element.classList.add('is-animated');
						if (index < elements.length - 1) {
							gsap.to(elements[index + 1].element, {
								scrollTrigger: {
									trigger: elements[index + 1].element,
									start: 'top center',
									end: 'bottom center',
									// markers: true,
									onEnter: () => {
										document.querySelector(elements[index + 1].element).classList.add('is-animated');
									},
								},
							});
						}
					},
				},
			});
		});
		function cleanTrigger() {
			aniSec = Array.prototype.filter.call(aniSec, function (ani) {
				return !ani.classList.contains('is-animated');
			});
		}
	}

	popup.$element.on('closed.zf.reveal', function() {
		mainAnimation();
	});

	// 暫時關閉用動畫
	// mainAnimation();
	

	/* ---------------------------------------- [START] 整頁 Scroll 監測 (After) */
	var pageScrollThrottle = null;
	var pageScrollHandler = function () {
		for (var i = 0; i < pageScrollCheckList.length; i++) {
			if (isInViewport(pageScrollCheckList[i].el)) {
				pageScrollCheckList[i].fun();
				pageScrollCheckList[i].build = true;
			}
		}

		// Clear
		pageScrollClear();

		// Stop
		if (pageScrollCheckList.length === 0) {
			off(window, 'scroll', pageScrollThrottle);
		}
	};

	on(window, 'load', function() {
		pageScrollThrottle = throttle(pageScrollHandler, 50, 1000); // 節流作用
		on(window, 'scroll', pageScrollThrottle);
		pageScrollHandler();
	});
})(window, document);

/* ----------------------------------- [START] set popup title resize */
function popupTitle($modal) {
	var $title = $modal.find('.store_popup__con-title');
	var titleText = $title.text();

	if (window.matchMedia("(min-width: 768px)").matches) {
		var screenWidth = $(window).width();
		var titleLength = titleText.length;

		// 如標題小於十個字設定字體大小填滿螢幕寬度80%
		if (titleLength > 10) {
			var fontSize = (screenWidth * 0.8) / titleLength;
			$title.css('font-size', fontSize + 'px');
		}
	}

	var $imgTop = $modal.find('.store_popup__img');
	var $titleHeight = $title.innerHeight();
	var titleHeightHalf = $titleHeight / 2;
	$imgTop.css('margin-top', '-' + titleHeightHalf + 'px');
	
	console.log('title height: ' + $titleHeight);
}

$(document).on('open.zf.reveal', '.store_popup', function () {
  var $modal = $(this);
  popupTitle($modal);
});
